import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-77ac0386")

_pushScopeId("data-v-77ac0386")
const _hoisted_1 = { class: "video-mock" }
const _hoisted_2 = { class: "mockBlock" }
const _hoisted_3 = { class: "usersCount" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: ["usersBlock", _ctx.blockClasses]
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.lastUsers, (user) => {
          return (_openBlock(), _createBlock("p", {
            class: "name",
            innerHTML: _ctx.mockName(user.stream.title.label)
          }, null, 8, ["innerHTML"]))
        }), 256))
      ], 2),
      _createVNode("p", _hoisted_3, _toDisplayString(_ctx.endpointsMedia.length - _ctx.index) + " " + _toDisplayString(_ctx.t('others')), 1)
    ])
  ]))
})